'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['buildingStageItems', 'activePostIndex', 'backButtonLabel', 'nextButtonLabel', 'ofDelimiter'],

    methods: {
        goToSlide: function goToSlide(index) {
            history.pushState(this.activePostIndex + 1, null, this.buildingStageItems[index].link);
            this.showSlide(index);
            (0, _jquery2.default)('html, body').animate({ scrollTop: 0 }, 'fast');
        },
        showSlide: function showSlide(index) {
            this.activePostIndex = index;
            document.getElementsByClassName("breadcrumbs__crumb--second")[0].innerHTML = this.buildingStageItems[this.activePostIndex].title;
        },
        getNextSlideIndex: function getNextSlideIndex() {
            if (this.activePostIndex < this.buildingStageItems.length - 1) return this.activePostIndex + 1;else return 0;
        },
        getPreviousSlideIndex: function getPreviousSlideIndex() {
            if (this.activePostIndex > 0) return this.activePostIndex - 1;else return this.buildingStageItems.length - 1;
        },
        goToNextSlide: function goToNextSlide() {
            var nextSlideIndex = this.getNextSlideIndex();
            this.goToSlide(nextSlideIndex);
        },
        goToPreviousSlide: function goToPreviousSlide() {
            var previousSlideIndex = this.getPreviousSlideIndex();
            this.goToSlide(previousSlideIndex);
        }
    },

    computed: {
        nextItemTitle: function nextItemTitle() {
            return this.buildingStageItems[this.getNextSlideIndex()].title;
        },
        previousItemTitle: function previousItemTitle() {
            return this.buildingStageItems[this.getPreviousSlideIndex()].title;
        }
    },

    ready: function ready() {
        document.getElementById('no-js-fallback-content').style.display = "none";
        var _ = this;

        // Browser back button handler
        window.addEventListener('popstate', function (event) {
            // get active slide by slug
            var slugArray = event.path[0].location.href.split("/");
            slugArray.pop(); // drop last empty element

            var slug = slugArray.pop();

            _.buildingStageItems.forEach(function (item, index) {
                if (item.slug === slug) {
                    _.showSlide(index);
                }
            });
        });
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<section class=\"stage-slider\">\n    <div class=\"stage-slider__toggler\">\n        <a v-on:click=\"goToPreviousSlide\" class=\"stage-slider__button stage-slider__button--prev\">{{ backButtonLabel }}</a>\n        <span class=\"stage-slider__index\">\n            <span class=\"stage-slider__count stage-slider__count--current\">{{ activePostIndex+1 }}</span>\n            <span class=\"stage-slider__count stage-slider__count--title\"> {{ ofDelimiter }} </span>\n            <span class=\"stage-slider__count stage-slider__count--total\">{{ buildingStageItems.length }}</span>\n        </span>\n        <a v-on:click=\"goToNextSlide\" class=\"stage-slider__button stage-slider__button--next\">{{ nextButtonLabel }}</a>\n    </div>\n    <header class=\"stage-slider__header\">\n        <a v-on:click=\"goToPreviousSlide\" class=\"stage-slider__step stage-slider__step--prev\">\n            {{ previousItemTitle }}\n        </a>\n        <h2 class=\"stage-slider__title title title--h1\">{{ buildingStageItems[activePostIndex].title }}</h2>\n        <a v-on:click=\"goToNextSlide\" class=\"stage-slider__step stage-slider__step--next\">\n            {{ nextItemTitle }}\n        </a>\n    </header>\n    <article class=\"stage-slider__content paragraph\">\n        {{{ buildingStageItems[activePostIndex].description }}}\n    </article>\n\n    <div class=\"stage-slider__page-list\">\n        <div class=\"stage-slider__mobile\">\n            <a v-on:click=\"goToPreviousSlide\" class=\"stage-slider__button  stage-slider__button--prev stage-slider__button--mobile\">{{ backButtonLabel }}</a>\n            <a v-on:click=\"goToNextSlide\" class=\"stage-slider__button  stage-slider__button--next stage-slider__button--mobile\">{{ nextButtonLabel }}</a>\n        </div>\n        <div class=\"stage-slider__tablet\">\n            <a v-on:click=\"goToPreviousSlide\" class=\"stage-slider__button stage-slider__button--prev\">{{ backButtonLabel }}</a>\n            <template v-for=\"buildingStageItem in buildingStageItems\">\n                <template v-if=\"buildingStageItem.id == buildingStageItems[activePostIndex].id\">\n                    <a v-on:click=\"goToSlide($index)\" class=\"stage-slider__count stage-slider__count--active\">{{ $index+1 }}</a>\n                </template>\n                <template v-else=\"\">\n                    <a v-on:click=\"goToSlide($index)\" class=\"stage-slider__count\">{{ $index+1 }}</a>\n                </template>\n            </template>\n            <a v-on:click=\"goToNextSlide\" class=\"stage-slider__button stage-slider__button--next\">{{ nextButtonLabel }}</a>\n        </div>\n    </div>\n</section>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7b1332a4", module.exports)
  } else {
    hotAPI.update("_v-7b1332a4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}